export default __webpack_public_path__ + "static/media/tiger.ed49f8c4.png";